import Vue from "vue";

import VueAnalytics from "vue-analytics";
// Configuration VueAnalytics

import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "G-LJKQTGDC0N" },
});

import { store } from "./store/store.js";
// ///////////////////////////////////////////////////////////////////////////////
import PrettyCheckbox from "pretty-checkbox-vue";

Vue.use(PrettyCheckbox);
// ///////////////////////////////////////////////////////////////////////////////
import VueRouter from "vue-router";

import VueToastr from "vue-toastr";
// use plugin
Vue.use(VueToastr, {
  /* OverWrite Plugin Options if you need */
  defaultTimeout: 3000,
  defaultProgressBar: false,
  defaultProgressBarValue: true,
  // defaultType: "error",
  defaultPosition: "toast-bottom-full-width",
  defaultCloseOnHover: false,
  defaultStyle: {
    "text-align": "center",
    "z-index": "10000000000000000000000000000000000000001",
    "font-family": "yekan",
    direction: "rtl",
  },
  defaultClassNames: ["animated", "zoomInUp"],
  // style:{
  //   text-align:center
  // }
});
Vue.use(require("vue-jalali-moment"));

import VueMeta from "vue-meta";
Vue.use(VueMeta);

// console.log(Vue.moment().locale()) //es

Vue.use(VueRouter);
import { routes } from "./router/routes.js";
const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    // console.log('scroll')
    return { x: 0, y: 0 };
  },
  mode: "history",
});

Vue.use(VueAnalytics, {
  id: "G-LJKQTGDC0N",
  routes,
});

import App from "./App.vue";

import VueAwesomeSwiper from "vue-awesome-swiper";

// import style (>= Swiper 6.x)
import "swiper/swiper-bundle.css";

// import style (<= Swiper 5.x)
// import 'swiper/css/swiper.css'

Vue.use(VueAwesomeSwiper /* { default options with global component } */);

///////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////

import VueVideoPlayer from "vue-video-player";

// require videojs style
import "video.js/dist/video-js.css";
// import 'vue-video-player/src/custom-theme.css'

Vue.use(
  VueVideoPlayer /* {
  options: global default options,
  events: global videojs events
} */
);

///////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////

global.jQuery = require("jquery");
var $ = global.jQuery;
window.$ = $;
// import VueScrollmagic from "vue-scrollmagic";
// Vue.use(VueScrollmagic);

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import {
  faInstagram,
  faGoogle,
  faLinkedin,
  faTwitter,
  faTelegram,
} from "@fortawesome/free-brands-svg-icons";
import {
  faInfoCircle,
  faDownload,
  faUserGraduate,
  faEyeSlash,
  faEye,
  faUsers,
  faHourglassHalf,
  faUniversity,
  faClipboard,
  faFilter,
  faPlus,
  faAngleDown,
  faUserCircle,
  faTimesCircle,
  faUserEdit,
  faSearch,
  faArrowDown,
  faEnvelope,
  faSignOutAlt,
  faCog,
  faKey,
  faInfo,
  faBell,
  faCheck,
  faComments,
  faUsersCog,
  faImage,
  faPortrait,
  faTrash,
  faEnvelopeOpenText,
  faAlignRight,
  faAlignLeft,
  faTags,
  faCheckDouble,
  faBookOpen,
  faFileAlt,
  faUpload,
  faAlignCenter,
  faUnderline,
  faItalic,
  faBold,
  faListOl,
  faListUl,
  faLink,
  faSort,
  faOutdent,
  faIndent,
  faCommentMedical,
  faBars,
  faFire,
  faShoppingCart,
  faShapes,
  faArrowLeft,
  faPhone,
  faStore,
  faShieldAlt,
  faSave,
  faClipboardList,
  faUser,
  faHeart,
  faShareAlt,
  faPlay,
  faTrashAlt,
  faPause,
  faFile,
  faStepForward,
  faPhotoVideo,
  faAngleLeft,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";

Vue.component("font-awesome-icon", FontAwesomeIcon);

library.add(
  faAngleLeft,
  faAngleRight,
  faPhotoVideo,

  faInfoCircle,
  faFile,
  faStepForward,
  faPlay,
  faPause,
  faTrashAlt,
  faShareAlt,
  faHeart,
  faUser,
  faClipboardList,
  faSave,
  faShieldAlt,
  faPhone,
  faStore,
  faArrowLeft,
  faShapes,
  faShoppingCart,
  faFire,
  faBars,
  faCommentMedical,
  faOutdent,
  faIndent,
  faSort,
  faLink,
  faListUl,
  faListOl,
  faBold,
  faItalic,
  faUnderline,
  faAlignCenter,
  faUpload,
  faFileAlt,
  faBookOpen,
  faCheckDouble,
  faTags,
  faDownload,
  faUserGraduate,
  faEyeSlash,
  faEye,
  faUsers,
  faHourglassHalf,
  faUniversity,
  faClipboard,
  faFilter,
  faTrash,
  faLinkedin,
  faPlus,
  faInstagram,
  faGoogle,
  faTwitter,
  faTelegram,
  faAngleDown,
  faUserCircle,
  faTimesCircle,
  faUserEdit,
  faSearch,
  faArrowDown,
  faEnvelope,
  faSignOutAlt,
  faCog,
  faKey,
  faInfo,
  faBell,
  faCheck,
  faComments,
  faUsersCog,
  faImage,
  faPortrait,
  faEnvelopeOpenText,
  faAlignRight,
  faAlignLeft
);

new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    $.ajax({
      url: store.state.url + "api/v1/token/verify/",
      crossDomain: true,
      data: {
        token: localStorage.getItem("profile"),
      },
      xhrFields: {
        withCredentials: true,
      },
      type: "POST",
      success: function (data, textStatus, request) {
        // console.log("checked");
        next();
      },
      error: function (request, textStatus, errorThrown) {
        // console.log("not cheked");
        // console.log(request.responseJSON);
        // console.log(localStorage.getItem("access"));
        next({
          path: "/login",
        });
      },
    });
  } else {
    next();
  }
});

if (window.location.pathname == "/login") {
  if (localStorage.getItem("profile")) {
    // console.log('broun')
    router.push("/profile");
  }
}

if (
  window.location.pathname == "/profile" ||
  window.location.pathname == "/profile/address" ||
  window.location.pathname == "/profile/pass-change" ||
  window.location.pathname == "/profile/favlist" ||
  window.location.pathname == "/profile/myorder" ||
  window.location.pathname == "/profile/myorder/details"
) {
  store.state.load = true;
  $.ajax({
    url: store.state.url + "api/v1/token/verify/",
    crossDomain: true,
    data: {
      token: localStorage.getItem("profile"),
    },
    xhrFields: {
      withCredentials: true,
    },
    type: "POST",
    success: function (data, textStatus, request) {
      // console.log("checked");
      store.state.load = false;
    },
    error: function (request, textStatus, errorThrown) {
      // console.log("not cheked");
      router.push("/login");
      store.state.load = false;
    },
  });
}

import VueNumberInput from "@chenfengyuan/vue-number-input";

Vue.use(VueNumberInput);
// Or
Vue.component(VueNumberInput.name, VueNumberInput);
// Or
Vue.component("vue-number-input", VueNumberInput);

// Vue.component('vue-multiselect', VueMultiselect.default)

import Paginate from "vuejs-paginate";
Vue.component("paginate", Paginate);

// if (localStorage.getItem("profile")) {
//   $.ajax({
//     url: store.state.url + "api/v1/token/verify/",
//     crossDomain: true,
//     data: {
//       token: localStorage.getItem("profile")
//     },
//     xhrFields: {
//       withCredentials: true
//     },
//     type: "POST",
//     success: function(data, textStatus, request) {
//       console.log(data,'456789')
//     },
//     error: function(request, textStatus, errorThrown) {
//     }
//   });
// }

const now = new Date();
// console.log(now.getTime())
// console.log(localStorage.getItem('ex'))
// console.log(shj,'456')
// console.log(now,'456')
const shj = new Date(localStorage.getItem("ex"));
// const shj = false
// console.log(shj,'gggggggggggggggggggggg', localStorage.getItem('ex'))
if (localStorage.getItem("ex")) {
  if (now >= shj) {
    // console.log('ex')
    localStorage.removeItem("profile");
    localStorage.removeItem("name");
    localStorage.clear();
    // localStorage.setItem("exflag", "false");
    // if (localStorage.getItem('exflag')) {
    location.reload();
    // }
  } else {
    // console.log('no ex')
  }
}

// function getWithExpiry(key) {
// 	const itemStr = localStorage.getItem(key)
// 	// if the item doesn't exist, return null
// 	if (!itemStr) {
// 		return null
// 	}
// 	const item = JSON.parse(itemStr)
// 	const now = new Date()
// 	// compare the expiry time of the item with the current time
// 	if (now.getTime() > localStorage.getItem("ex")) {
// 		// If the item is expired, delete the item from storage
// 		// and return null
// 		localStorage.removeItem(key)
// 		return null
// 	}
// 	return item.value
// }

// getWithExpiry('profile')

///////////////////////////////////////////////////////////////////////////////
// const router = new Router({ /* Your Router config go here */ });

function getRoutesList(routes, pre) {
  return routes.reduce((array, route) => {
    const path = `${pre}${route.path}`;

    if (route.path !== "*") {
      array.push(path);
    }

    if (route.children) {
      array.push(...getRoutesList(route.children, `${path}`));
    }

    return array;
  }, []);
}

getRoutesList(router.options.routes, "https://suncandle.ir");

function getRoutesXML() {
  const list = getRoutesList(router.options.routes, "https://suncandle.ir")
    .map((route) => `<url><loc>${route}</loc></url>`)
    .join("\r\n");
  //   console.log(`<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
  //   ${list}
  // </urlset>`)
  return `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
    ${list}
  </urlset>`;
}

getRoutesXML();

import VueCoreVideoPlayer from "vue-core-video-player";

Vue.use(VueCoreVideoPlayer);



// WEBPACK FOOTER //
// ./src/main.js